<template>
<!--        <RecycleScroller-->
<!--                :style="scrollerStyle"-->
<!--                :items="itemIndexes"-->
<!--                :item-size="cellHeight"-->
<!--                key-field="info"-->
<!--        >-->
    <RecycleScroller
            :style="scrollerStyle"
            :items="itemIndexes"
            :item-size="cellHeight"
    >
<!--         <template #before>-->
<!--             Hey! I'm a message displayed before the items!-->
<!--         </template>-->
         <template v-slot="props" :style="scrollerStyle">
             <div class="cell-view" @click="onClick(props.index)">
                 <div class="image-box">
                     <img :src="thumbnailUrl(itemSource[props.item].dir)" height="100%" :alt="itemSource[props.item].info.title">
                     <div class="image-box-button">
                         <button style="width: 60%; height: 24px;" @click.stop="fireEvent(props.index)">読む</button>
                     </div>
                 </div>
                 <div class="wf-mincho info-box">
                     <div class="title-area">
                         {{itemSource[props.item].info.title}}
                     </div>
                     <div class="author-area">
                         {{itemSource[props.item].info.author}}
                     </div>
                     <div class="caption-area" :style="{overflow:(props.index === activeCaption) ? 'scroll' : 'hidden'}" @click.stop="activeCaption = props.index">{{itemSource[props.item].info.main_caption}}</div>
                 </div>
             </div>
         </template>
    </RecycleScroller>
</template>

<script>
  let debugOut = false
  import {mapState} from 'vuex'
   export default {
    name: "WorklistTable",
    components: {
    },
    data() {
      return {
        cellHeight: 160,
        activeCaption:-1,
       }
    },
    props: {
      itemIndexes:Array,
      itemSource:Array,
    },
    created() {
      debugOut = this.$root.$options.debugOut
    },
    mounted() {
      if (debugOut) { console.log("Work list table !!") }
    },
    computed: {
      papiDir() {
        return this.$root.$options.commandPath
      },
      scrollerStyle() {
        return {
          '--cell-height'       : this.cellHeight+'px',
          '--title-size'        : '1.1em',
          '--author-size'       : '0.9em',
        }
      },
      ...mapState([
        // 'documentAreaWidth',
        // 'documentAreaHeight',
      ]),
    },
    methods: {
      onScroll(e) {
        if (debugOut) { console.log(e) }
      },
      thumbnailUrl(t) {
        return `${this.$root.$options.sharePath}/${t}/thumbnail.jpg`
      },
      onClick(i) {
        if (debugOut) {console.log(`click cell index ${i}`)}
      },
      fireEvent(i) {
        if (debugOut) {console.log(`fire event cell index ${i}`)}
        this.$emit("click",i)
      },
    },
  }
</script>

<style scoped lang="scss">

    .image-box {
        display: inline-block;
        position: relative;
        width: calc(var(--cell-height) - 40px);
        height: calc(var(--cell-height) - 40px);
        padding: 4px;
        img {
            width: 100%;
            height: 100%;
            object-fit: scale-down;
        }
    }
    .image-box-button {
        display: block;
        width: 100%;
        text-align: center;
    }

    .info-box {
        width: calc(100% - var(--cell-height) - 8px);
        height: calc(var(--cell-height) - 8px);
        overflow: hidden;
        display: inline-block;
        margin-left: 4px;
        vertical-align: top;
    }

    .title-area {
        color: #333333;
        font-size: var(--title-size);
        font-weight: bold;
        text-align: center;
        width: 100%;
        height: var(--title-size);
    }

    .author-area {
        color: #333333;
        font-size: var(--author-size);
        text-align: center;
        width: 100%;
        height: calc(var(--author-size) + 8px);
    }

    .caption-area {
        color: #1e538c;
        font-size: 0.8em;
        text-align: left;
        width: 100%;
        margin: 0;
        height: calc(100% - var(--title-size) - var(--author-size) - 12px);
        font-family: sans-serif;
        white-space: pre-wrap;
    }

    .cell-view {
        width: 96%;
        height: var(--cell-height);
        margin-left: 2%;
        float: left;
        text-align: left;
        border-bottom: 1px solid darkgray;
    }
</style>